// extracted by mini-css-extract-plugin
module.exports = {"uploaded-file-list":"uploaded-file-list__3uOj4","header":"header__wdkch"};